(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("router", [], factory);
	else if(typeof exports === 'object')
		exports["router"] = factory();
	else
		root["router"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./lib/js/router.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./definition/router-definition.json":
/*!*******************************************!*\
  !*** ./definition/router-definition.json ***!
  \*******************************************/
/*! exports provided: config, routes, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"config\":{\"api\":{\"baseUrl\":\"BASE_URL\"},\"api.activities\":{\"baseUrl\":\"BASE_URL_ACTIVITY_API\"},\"api.content\":{\"baseUrl\":\"BASE_URL_CONTENT_API\"},\"api.callbacks\":{\"baseUrl\":\"BASE_URL_CALLBACKS_API\"},\"api.dashboard\":{\"baseUrl\":\"BASE_URL_DASHBOARD_API\"},\"api.learning_spa\":{\"baseUrl\":\"BASE_URL_LEARNING_SPA\"},\"api.learning\":{\"baseUrl\":\"BASE_URL_LEARNING_API\"},\"api.user_report\":{\"baseUrl\":\"BASE_URL_REPORT_API\"},\"api.platform\":{\"baseUrl\":\"BASE_URL_PLATFORM_API\"},\"api.marketplace\":{\"baseUrl\":\"BASE_URL_MARKETPLACE_API\"},\"api.monitor\":{\"baseUrl\":\"BASE_URL_MONITOR_API\"}},\"routes\":{\"pages\":{\"funding_search_profile\":\"/funding-search/:fundingSearchId/profile\",\"funding_search_profile_response\":\"/funding/search/:fundingSearchId/responses\",\"funding_search_profile_offers\":\"/funding-search/:fundingSearchId/offers\",\"funding_report_profile\":\"/funding/report/:reportId\",\"manage_lending_criteria\":\"/lender/criteria\",\"share_lead\":\"/funding-search/create\"},\"api\":{\"me\":\"/api/v1/me\",\"networkSignup\":\"/learn/signup\",\"active_lenders\":\"/api/lenders/active\",\"send_invite\":\"/api/v1/user/invite\",\"notifications\":\"/api/v1/notifications/:page\",\"notifications_mark_as_seen\":\"/api/v1/notifications/seen\",\"notification_mark_as_read\":\"/api/v1/notifications/:notificationId/read\",\"dashboard_configuration\":\"/api/v1/dashboard/configuration\",\"funding_report\":\"/api/v1/funding-report\",\"funding_report_convert\":\"/api/v1/funding/report/:reportId/to/funding/search\",\"funding_report_detail\":\"/api/v1/funding/report/:reportId\",\"funding_search_active\":\"/api/v1/funding/active\",\"funding_search_completed\":\"/api/v1/funding/completed\",\"funding_search_shared\":\"/api/v1/funding/shared\",\"resend_invite_funding_report\":\"/api/v1/funding/report/:reportId/resend\",\"lead_require_action\":\"/api/v1/lead/require-action\",\"lead_new\":\"/api/v1/lead/new\",\"lead_active\":\"/api/v1/lead/active\",\"lead_completed\":\"/api/v1/lead/completed\",\"funding_search_list_faqs\":\"/api/v1/faqs\",\"create_funding_report\":\"/api/v1/funding/report\",\"funding_report_invite_url\":\"/api/v1/funding/report/url\",\"funding_search_upload\":\"/api/v1/funding/search/:fundingSearchId/document\",\"funding_search_download\":\"/api/v1/funding/search/:fundingSearchId/document/:documentId\",\"funding_search_remove\":\"/api/v1/funding/search/:fundingSearchId/document/:documentId\",\"cancel_funding_search\":\"/api/v1/funding/search/:fundingSearchId/cancel\",\"funding_search_privacy_toggle\":\"/api/v1/funding/search/:fundingSearchId/privacy-toggle\",\"delete_profile\":\"/api/v1/funding/search/:fundingSearchId/delete\",\"refresh_token\":\"/api/v1/auth/token/refresh\",\"funding_search_profile\":\"/api/v1/funding/search/:fundingSearchId/profile\",\"funding_search_banner_dismiss\":\"/api/v1/funding/search/:fundingSearchId/banner/dismiss\",\"funding_search_call_me\":\"/api/v1/funding/search/:fundingSearchId/request-help\",\"funding_search_offers\":\"api/v1/funding/search/:fundingSearchId/offers\",\"funding_search_company_search\":\"/ajax/company/search/\",\"funding_profile_send_company_report\":\"api/v1/profile/send/company-report\",\"update_funding_search_profile_section\":\"/api/v1/funding/search/:fundingSearchId/profile/section/:sectionId\",\"request_update_funding_search_profile_section\":\"/api/v1/funding/search/:fundingSearchId/profile/section/:sectionId/request-update\",\"complete_funding_search_profile_section\":\"/api/v1/funding/search/:fundingSearchId/profile/section/:sectionId/complete\",\"download_funding_search_profile_attachment\":\"/api/v1/funding/search/:fundingSearchId/attachment\",\"download_funding_search_documents\":\"/api/v1/funding/search/:fundingSearchId/attachments/download\",\"funding_search_request_documents\":\"/api/v1/funding/search/:fundingSearchId/request/documents\",\"funding_search_update_funding_match\":\"/api/v1/funding/search/:fundingSearchId/funding/match/update/status\",\"integration_authorization_url\":\"/api/v1/auth/handler/:integration/authorization-url\",\"integration_authorization_invite_url\":\"/api/v1/auth/handler/:integration/authorization-url/invite\",\"disconnect_integration_url\":\"/api/v1/auth/disconnection/:integration\",\"create_business_entity\":\"/api/v1/entity/business\",\"introducer_get_managed_entities\":\"/api/v1/entity/:entityId/introducer/managed-entities\",\"entity_get_by_id\":\"/api/v1/entity/:entityId\",\"create_entity_profile\":\"/api/v1/entity/:entityId/profile\",\"get_entity_profile\":\"/api/v1/entity/:entityId/profile\",\"update_entity_profile_section\":\"/api/v1/entity/:entityId/profile/:sectionId\",\"get_funding_match\":\"/api/v1/funding/match/:fundingMatchId\",\"cancel_funding_match\":\"/api/v1/funding/match/:fundingMatchId/cancel\",\"funding_match_application\":\"/api/v1/funding/application/:fundingMatchId\",\"funding_match_remove_offer\":\"/api/v1/funding/match/:fundingMatchId/offer/:documentId\",\"user_preferences\":\"/api/v1/user/preferences\",\"update_onboarding_preferences\":\"/api/v1/user/profile/preference/onboarding/:preference\",\"lender_criteria_summary\":\"/api/v1/criteria\",\"criteria_product_status\":\"/api/v1/criteria/:section/status\",\"criteria_product\":\"/api/v1/criteria/:section\",\"request_help\":\"/api/v1/funding/search/:fundingSearchId/invite\",\"questionnaireCompleteApplication\":\"/api/v1/questionnaire/complete/application\",\"get_user\":\"/api/v1/users/:id\",\"dashboard\":{\"funding_search_kpi\":\"/v1/card/funding/search/overview\",\"leads_overview\":\"/v1/card/lead/overview\",\"leads_total_approved\":\"/v1/card/user/total-approved\",\"lender_response_time\":\"/v1/card/lender/response-time\",\"searches_requiring_attention\":\"/v1/card/funding/search/requiring-attention\"},\"activities\":{\"funding_search_activities\":\"/v1/funding/:fundingSearchId/activities\",\"funding_search_dismiss_activity\":\"/v1/activity/:activityId/dismiss\",\"activity_action\":\"/v1/activity/:activityId/action/:action\",\"complete_activity\":\"/v1/activity/:activityId/complete\",\"activities_grouped_by_funding_search\":\"/v1/activities/grouped-by-funding-search\",\"funding_match_decline\":\"/v1/activity/:activityId/action/reject-offer\",\"due_activities_count\":\"/v1/activities/due-by-funding-search\",\"all\":\"/activities\"},\"marketplace\":{\"authorize\":\"/v1/auth/authorize\",\"cases_apply\":\"/v1/profiles/:profileId/cases/apply\",\"company\":\"/v1/companies/:companyNumber\",\"company_search\":\"/v1/companies/search/:companyInfo\",\"company_search_v2\":\"/v1/companies/search/variant/:companyInfo\",\"companies_update\":\"/v1/profiles/:profileId/companies\",\"matches_apply\":\"/v1/profiles/:profileid/funding/apply\",\"matches_results\":\"/v1/profiles/:profileId/funding/matches/results\",\"matches_count\":\"/v1/profiles/:profileId/funding/matches/count\",\"profile_get\":\"/v1/profiles/:profileId\",\"profile_new\":\"/v1/profiles/blank\",\"profile_new_entity\":\"/v1/profiles/blank/:entityId\",\"profile_new_anonymous\":\"/v1/profiles/anonymous\",\"profile_set_ownership\":\"/v1/profiles/:profileId/set-ownership\",\"profile_submit\":\"/v1/questionnaires/:questionnaireId/profiles/:profileId/answers\"},\"monitor\":{\"business-score\":\"/v1/business-score\",\"batch_start\":\"/v1/entities/snapshots/batch/start\",\"batch_by_id\":\"/v1/entities/snapshots/batch/:batchId\",\"batch_by_id_start\":\"/v1/entities/snapshots/batch/:batchId/process\",\"batch_by_id_store\":\"/v1/entities/snapshots/batch/:batchId/store\",\"accounts\":\"/v1/entities/:entityId/integration/accounts\",\"monitor_snapshot_accounts\":\"/v1/entities/:entityId/accounts\",\"mark_monitor_snapshot_accounts_as_viewed\":\"/v1/entities/:entityId/accounts/:accountId\",\"business_funding_searches\":\"/v1/entities/:entityId/funding-searches\",\"clients\":\"/v1/entities/:entityId/introducer/clients\",\"clients_actions\":\"/v1/entities/:entityId/introducer/clients/actions\",\"conversations\":\"v1/entities/:entityId/introducer/clients/conversations\",\"client\":\"/v1/entities/:entityId\",\"client_archive\":\"/v1/entities/:entityId/archive\",\"create_snapshot\":\"/v1/entities/:entityId/snapshots\",\"export_clients\":\"/v1/entities/:entityId/introducer/clients/export\",\"funding_report_matches\":\"/v1/product-matches-by-report\",\"integration_removal\":\"/v1/entities/:entityId/connections/disconnect\",\"accounting_integration_removal\":\"/v1/entities/:entityId/connections/accounting/disconnect\",\"banking_integration_removal\":\"/v1/entities/:entityId/connections/banking/disconnect\",\"entity_facilities\":\"/v1/entities/:entityId/facilities\",\"delete_facility\":\"/v1/entities/:entityId/facilities/:id\",\"snapshot\":\"/v1/entities/:entityId/snapshots/latest\",\"snapshot_timeline\":\"/v1/entities/:entityId/snapshots/timeline\",\"overall_stats\":\"/v1/cards/clients/overall-stats\",\"product_matches\":\"/v1/product-matches\",\"clients_requiring_attention\":\"/v1/cards/clients/requiring-attention\",\"clients_total\":\"/v1/cards/clients/total\",\"delete_credit_line_facility\":\"/v1/entities/:entityId/credit-line-facilities/:creditLineId\",\"tags\":\"/v1/entities/tags\",\"tag_edit\":\"/v1/entities/tags/:tagId\",\"tag_assign\":\"/v1/entities/:entityId/tags/assignments\",\"tag_unassign\":\"/v1/entities/:entityId/tags/assignments/:tagId\",\"insights_client_count\":\"/v1/entities/:entityId/introducer/clients/insights\"},\"platform\":{\"add_client\":\"/v1/entities/clients\",\"api_key\":\"/v1/permissions/:scope\",\"auth_login\":\"/v1/auth/login\",\"auth_signin\":\"/v1/auth/authorize\",\"auth_signup\":\"/v1/auth/signup\",\"alpha_auth_signup\":\"/v1/auth/sign-up\",\"alpha_auth_signup_token\":\"/v1/auth/sign-up/:token\",\"invite_team_member\":\"/v1/auth/invite/sign-up\",\"signup_hash\":\"/v1/auth/sign-up/hash/:token\",\"cases\":\"/v1/cases\",\"cases_summary\":\"/v1/cases/summary\",\"cases_latest\":\"/v1/cases/latest\",\"cases_actions\":\"/v1/cases/dashboard/actions\",\"caseById\":\"/v1/cases/:id\",\"caseActivities\":\"/v1/cases/:id/activities\",\"cancel_case\":\"v1/cases/:id/cancel\",\"client\":\"/v1/entities/:entityId\",\"entities\":\"/v1/entities\",\"entity_all\":\"/v1/entities/:entityId/all\",\"delete_case\":\"v1/cases/:id/delete\",\"download_credit_report_pdf\":\"/v1/credit-reports/:companyNumber/creditsafe\",\"enquiry_activities\":\"/v1/entities/funding/enquiries/activities\",\"enquiry_create\":\"/v1/funding/enquiries\",\"enquiry_questions\":\"/v1/funding/enquiries/questions\",\"enquiry_update_status\":\"/v1/entities/funding/enquiries/:id/statuses\",\"events_access_token\":\"/v1/events/access\",\"events_stream\":\"/v1/events\",\"funding_match_offer_schema\":\"/v1/funding/searches/:fundingSearchId/matches/:fundingMatchId/offers/schema\",\"funding_match_upload_offer_documents\":\"/v1/funding/matches/:fundingMatchId/offers/documents\",\"funding_matches_offers\":\"/v1/funding/matches/:matchId/offers\",\"funding_matches_offers_history\":\"/v1/funding/matches/:matchId/offers/history\",\"funding_matches\":\"/v1/funding/matches/:matchId\",\"funding_search_by_id\":\"/v1/funding/searches/:fundingSearchId\",\"funding_search_company_search\":\"/v1/companies/search/:companyInfo\",\"funding_search_company_search_variant\":\"/v1/companies/search/variant/:companyInfo\",\"funding_search_price_estimates\":\"/v1/funding/searches/:fundingSearchId/price-estimates\",\"get_clients\":\"/v1/entities/clients\",\"get_enquiries\":\"/v1/entities/funding/enquiries\",\"get_partner\":\"/v1/expirable/tokens/:tokenId/partner\",\"get_user_enquiries\":\"/v1/users/funding/enquiries\",\"get_user_enquiry_activities\":\"/v1/users/funding/enquiries/activities\",\"get_user_enquiry\":\"/v1/users/funding/enquiries/:enquiryId\",\"lender_criteria\":\"/v1/criteria\",\"lender_criteria_summary\":\"/v1/criteria/summary\",\"leads\":\"/v1/leads/:filter\",\"matches_by_funding_search_id\":\"/v1/funding/searches/:fundingSearchId/matches\",\"me\":\"/v1/me\",\"networkGet\":\"/v1/networks\",\"networkSignup\":\"/v1/networks/register/learn\",\"patch_client\":\"/v1/entities/clients/:id\",\"patch_user_enquiry_seen\":\"/v1/users/funding/enquiries/:enquiryId/activities/read\",\"patch_user_enquiry\":\"/v1/users/funding/enquiries/:enquiryId\",\"questionnaire_filters_schema\":\"/v1/questionnaires/:questionnaireId/profiles/:profileId/filters-schema\",\"questionnaire_ui_schema\":\"/v1/questionnaires/:questionnaireId/profiles/:profileId/ui-schema\",\"serviceability_score\":\"/v1/facilities/serviceability/score\",\"snapshot\":\"/v1/profiles/:profileId/questionnaires/:questionnaireId/snapshots\",\"snapshot_available\":\"/v1/profiles/:profileId/snapshots/available\",\"credit-review-upload\":\"/v1/profiles/:profileId/documents/types/for-credit-review/:type\",\"profile-document\":\"/v1/profiles/:profileId/documents/:documentId\"},\"learning_spa\":{\"lesson_page\":\"/lessons/:path\"},\"learning\":{\"launch_lesson\":\"/lesson/:lessonId/launch\",\"lrs_health_check\":\"/lesson/:lessonId/health-check\",\"courses\":\"/courses\",\"courses_actions\":\"/courses/actions\"},\"content\":{\"collections\":\"/v1/collections/:type\",\"asset\":\"/v1/collection/asset/:id\",\"playbook\":\"/v1/collection/playbook\",\"playbookfilters\":\"/v1/collection/playbook/:id/filters\",\"playbook_shareable_url\":\"/v1/shareable/url\"},\"teams\":{\"verify_company_exists\":\"/api/v1/entity/:companyName/exists\",\"verify_user_exists\":\"/api/v1/user/:email/exists\",\"verify_users_exists\":\"/api/v1/users/exists\",\"invite_company\":\"/api/v1/network/:id/company/invite\",\"verify_team_exists\":\"api/v1/entity/:id/team/:teamName/exists\",\"company_add_team\":\"/api/v1/entity/:id/team/add\",\"my_team\":\"/api/v1/team/mine\",\"my_network\":\"/api/v1/network/mine\",\"my_company\":\"/api/v1/entity/mine\",\"my_teams\":\"/api/v1/teams/mine\",\"team\":\"/api/v1/teams/:id\",\"edit_team\":\"/api/v1/team/:id\",\"invite_more_members\":\"/api/v1/team/:teamId/users/invite\",\"update_role\":\"/api/v1/user/:userId/role/toggle\",\"view_team\":\"/api/v1/team/:teamId\",\"move_team_members\":\"/api/v1/team/:teamId/move-users\",\"report_entities\":\"/api/v1/report/entities\",\"resend_invite\":\"/api/v1/invite/:token/resend-invite\",\"make_champion\":\"/api/v1/team/:teamId/team-member/:teamMemberId/champion\"},\"invite\":{\"get_invite\":\"/api/v1/invite/:token\",\"signup\":\"/signup/:token\",\"reject\":\"/api/v1/invite/:token/reject\"},\"search_manager\":{\"funding_search_manager_update\":\"/api/v1/funding/search/:fundingSearchId/manager/:userId\"},\"search_followers\":{\"funding_search_followers\":\"/api/v1/funding/search/:fundingSearchId/followers\",\"funding_search_follower_toggle\":\"/api/v1/funding/search/:fundingSearchId/follower/:userId/toggle\"},\"company\":{\"users\":\"/api/v1/entity/:entityId/users\"},\"funding_search_contact_details\":{\"funding_search_contact_details\":\"/api/v1/funding/search/:fundingSearchId/contact-details\"},\"user_report\":{\"team_user_reports\":\"/v1/report/teams\"},\"membership\":{\"features_availability\":\"/api/v1/user/membership/feature\"},\"callbacks\":{\"connect\":\"/v1/cloud/authorization-url/provider/:provider/context/:context\",\"disconnect\":\"/v1/cloud/disconnect/provider/:provider/object/:objectId\",\"payment\":\"/v1/payments/checkout/:planId\"}}}}");

/***/ }),

/***/ "./lib/js/router.js":
/*!**************************!*\
  !*** ./lib/js/router.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _routerDefinition = __webpack_require__(/*! router-definition.json */ "./definition/router-definition.json");

var _routerDefinition2 = _interopRequireDefault(_routerDefinition);

var _urlHelper = __webpack_require__(/*! ./url-helper */ "./lib/js/url-helper.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = {
    routes: _routerDefinition2.default.routes,
    config: _routerDefinition2.default.config
};

function getProp(obj, keys, defaultValue) {
    if (typeof obj === 'undefined' || obj === null) {
        return defaultValue;
    }

    var result = obj[keys[0]];

    if (typeof result === 'undefined' || result === null) {
        return defaultValue;
    }

    return keys.length > 1 ? getProp(result, keys.slice(1), defaultValue) : result;
}

service.init = function init(config) {
    service.envConfig = config;

    return service;
};

service.getModuleConfig = function (routePath) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // If a config is found for the provided routePath return it
    if (service.config[routePath]) {
        return service.config[routePath] || defaultValue;
    }

    // Go back one subdomain and get the new path
    var newPath = routePath.split('.').slice(0, -1).join('.');

    // If no path is found.
    if (!newPath) {
        return defaultValue;
    }

    return service.getModuleConfig(newPath, defaultValue);
};

service.getBaseUrl = function (routePath) {
    return service.getModuleConfig(routePath, {}).baseUrl;
};

service.getPath = function (routeKey) {
    return getProp(service.routes, routeKey.split('.'));
};

service.generate = function generate(routeKey) {
    var interpolationObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var path = service.getPath(routeKey);
    var baseUrlKey = service.getBaseUrl(routeKey);
    var baseUrl = baseUrlKey ? service.envConfig[baseUrlKey] || '/' : '/';

    if (!path) {
        throw new Error('No route found with associated key: ' + routeKey);
    }

    return (0, _urlHelper.joinUrl)(baseUrl, (0, _urlHelper.interpolateParams)(path, interpolationObj));
};

exports.default = service;

/***/ }),

/***/ "./lib/js/url-helper.js":
/*!******************************!*\
  !*** ./lib/js/url-helper.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.interpolatePath = interpolatePath;
exports.interpolateParams = interpolateParams;
exports.joinUrl = joinUrl;

var _urlJoin = __webpack_require__(/*! url-join */ "./node_modules/url-join/lib/url-join.js");

var _urlJoin2 = _interopRequireDefault(_urlJoin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function interpolatePath(route, keyName, value) {
    var key = ':' + keyName;

    if (route.indexOf(key) >= 0) {
        return route.replace(new RegExp(key), value);
    }

    var separator = route.indexOf('?') >= 0 ? '&' : '?';

    var safeValue = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? JSON.stringify(value) : value;

    return '' + route + separator + keyName + '=' + safeValue;
}

function interpolateParams(rawPath) {
    var interpolation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(interpolation).reduce(function (path, key) {
        return interpolatePath(path, key, interpolation[key]);
    }, rawPath);
}

function joinUrl(baseUrl, path) {
    return (0, _urlJoin2.default)(baseUrl, path);
}

/***/ }),

/***/ "./node_modules/url-join/lib/url-join.js":
/*!***********************************************!*\
  !*** ./node_modules/url-join/lib/url-join.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, context, definition) {
  if ( true && module.exports) module.exports = definition();
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  else {}
})('urljoin', this, function () {

  function normalize (strArray) {
    var resultArray = [];

    // If the first part is a plain protocol, we combine it with the next part.
    if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
      var first = strArray.shift();
      strArray[0] = first + strArray[0];
    }

    // There must be two or three slashes in the file protocol, two slashes in anything else.
    if (strArray[0].match(/^file:\/\/\//)) {
      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
    } else {
      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
    }

    for (var i = 0; i < strArray.length; i++) {
      var component = strArray[i];

      if (typeof component !== 'string') {
        throw new TypeError('Url must be a string. Received ' + component);
      }

      if (component === '') { continue; }

      if (i > 0) {
        // Removing the starting slashes for each component but the first.
        component = component.replace(/^[\/]+/, '');
      }
      if (i < strArray.length - 1) {
        // Removing the ending slashes for each component but the last.
        component = component.replace(/[\/]+$/, '');
      } else {
        // For the last component we will combine multiple slashes to a single one.
        component = component.replace(/[\/]+$/, '/');
      }

      resultArray.push(component);

    }

    var str = resultArray.join('/');
    // Each input component is now separated by a single slash except the possible first plain protocol part.

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    var parts = str.split('?');
    str = parts.shift() + (parts.length > 0 ? '?': '') + parts.join('&');

    return str;
  }

  return function () {
    var input;

    if (typeof arguments[0] === 'object') {
      input = arguments[0];
    } else {
      input = [].slice.call(arguments);
    }

    return normalize(input);
  };

});


/***/ })

/******/ });
});
//# sourceMappingURL=router.js.map